import comp from "./OrganizationResourcesFeed";
export default comp;
